module.exports = __webpack_public_path__ + "static/media/banner3.321c66a2.png";